// Redux-connected estimate summary for the live intake form's sticky desktop
// right column. All rendering is delegated to EstimateSummaryPanelView so the
// admin branding preview can show the exact same UI with static state.
import { useSelector } from 'react-redux';
import EstimateSummaryPanelView from './EstimateSummaryPanelView.jsx';

const EstimateSummaryPanel = ({ onSendInquiry }) => {
  const area = useSelector((s) => s.area.stats.data);
  const estimate = useSelector((s) => s.selections.estimate);
  const selectedCount = useSelector((s) => s.selections.items.length);

  return (
    <EstimateSummaryPanelView
      area={area}
      estimate={estimate}
      selectedCount={selectedCount}
      onSendInquiry={onSendInquiry}
    />
  );
};

export default EstimateSummaryPanel;
